import { Button, InputAdornment, TextField } from "@material-ui/core"
import { Add, Search } from "@material-ui/icons"
import PropTypes from "prop-types"
import { useContext, useEffect } from "react"
import ActionBar from "~/components/ActionBar/index.jsx"
import AppContext from "~/contexts/App"
import { SubscriptionsContainer } from "~/contexts/Subscriptions"
import Page from "~/pages/Page"
import Router from "~/router"
import Box from "../../components/Common/Box"
import useStyles from "./styles"

const Subscriptions = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  const { setPageTitle, setPageSubTitle } = useContext(AppContext)

  useEffect(() => {
    setPageTitle("Subscriptions")
    setPageSubTitle("")
  }, [])

  return (
    <Page>
      <SubscriptionsContainer>
        <ActionBar
          elevation={0}
          left={() => (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Add fontSize="small" />}
            >
              New Subscription
            </Button>
          )}
          right={() => (
            <Box display="flex" alignItems="center">
              <TextField
                placeholder="Search subscriptions"
                style={{
                  flex: 10,
                  background: "white",
                  borderRadius: "4px",
                  marginLeft: "2vw",
                  width: "20vw",
                }}
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          )}
        />

        <Router routes={routes} {...rest} />
      </SubscriptionsContainer>
    </Page>
  )
}

Subscriptions.propTypes = {
  routes: PropTypes.array,
}

export default Subscriptions
